export default function Placeholder({ label = "IMAGE", className = "" }) {
  return (
    <div
      className={`relative overflow-hidden border border-white/10 bg-[#0c0c0c] ${className}`}
      data-testid={`placeholder-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="placeholder-texture absolute inset-0" />
      <span className="absolute left-3 top-3 font-spacemono text-[10px] text-white/25">+</span>
      <span className="absolute right-3 top-3 font-spacemono text-[10px] text-white/25">+</span>
      <span className="absolute bottom-3 left-3 font-spacemono text-[10px] text-white/25">+</span>
      <span className="absolute bottom-3 right-3 font-spacemono text-[10px] text-white/25">+</span>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
        <span className="h-1.5 w-1.5 bg-[#F97316]" />
        <span className="px-4 text-center font-spacemono text-[10px] uppercase tracking-[0.35em] text-white/40">
          {label}
        </span>
      </div>
    </div>
  );
}
